import { Component, Prop, Vue } from 'vue-property-decorator';
const Grid = require('../../../../../components/grid/grid.vue.html');
const NoteTaskList = require('../notetask/notetasklist.vue.html');
const PostHearingLetter = require('../../../letters/posthearingletter.vue.html');
import HearingService from '../../../../../services/HearingService';
import NoteTaskService from '../../../../../services/NoteTaskService';
import NoteTaskReq from '../../../../../models/NoteTaskReq';
import Details from '../../../../../models/Details';

@Component({
    components: {
        Grid,
        NoteTaskList
        , PostHearingLetter
    }
})
export default class DetailsForm extends Vue {

    @Prop({ type: Object as () => Details })
    public hearingDetails!: Details

    @Prop({ type: Boolean, default: true }) editable!: true;

    @Prop({ required: true }) id!: number;


    employerName: string = '';


    noteTaskDialog: Boolean = false;
    contactDialog: Boolean = false;
    postHearingLetterDialog: Boolean = false;
    hearingTimeMenu: Boolean = false;
    hearingDateMenu: Boolean = false;
    contactsData: any = {
        internalContacts: {},
        employerContacts: {}
    };
    notesAndTasks: any = {};
    //hearingReps: Array<any>[] = [];   //pulling these from store as it's the same data and it's pulled as ref data

    get displayName() {
        return this.hearingDetails.claimantNameFirst != '' ? ' - ' + this.hearingDetails.claimantNameLast + ', ' + this.hearingDetails.claimantNameFirst : '';
    }

    checkPrep() {
        if (this.hearingDetails.prepCompleted)
            if (this.hearingDetails.pendedReasons.length > 0)
                alert('You are about to mark this hearing as prep complete, but there are still pended reasons on the hearing.');
    }

    public service = new HearingService();
    public noteService = new NoteTaskService();

    loadNotesAndTasks() {
        console.log('loading data');
        if (this.hearingDetails != null) {

            let noteReq: NoteTaskReq = {
                hearingId: this.hearingDetails.pkHearing,
                pkLinkHearing: this.hearingDetails.fkLinkHearing,
                BWCClaimNum: this.hearingDetails.claimNumber,
                userName: this.$store.state.user.userName
            };
            this.noteService.GetNotesAndTasks(noteReq)
                .then((resp) => {
                    this.notesAndTasks = resp;

                    Vue.set(this.notesAndTasks, 'selected', []);
                    Vue.set(this.notesAndTasks, 'expanded', []);
                    this.$store.dispatch('isLoading', false);
                })
        }
    }

    toggleAll() {
        if (this.notesAndTasks.selected.length) this.notesAndTasks.selected = []
        else this.notesAndTasks.selected = this.notesAndTasks.data.slice()
    }

    mounted() {
        this.$store.dispatch('loadRefData');
        this.$store.dispatch('setApplicationName', 'Hearing Details');

        this.loadNotesAndTasks();
        this.employerName = this.hearingDetails.employerName;

        //this.service.GetHearingReps()
        //    .then((resp) => {
        //        this.hearingReps = resp.data;
        //    });

        this.service.GetTPAExternalContacts({ policyNumber: this.hearingDetails.policyNumber })
            .then((resp) => {
                this.contactsData.employerContacts = resp;
            });

        this.service.GetTPAInternalContacts({ policyNumber: this.hearingDetails.policyNumber })
            .then((resp) => {
                this.contactsData.internalContacts = resp;
            });

        this.$store.dispatch('isLoading', false);
    }

    saveDetails() {
        this.$validator.validate()
            .then(resp => {
                this.service.UpdateHearingDetails(this.hearingDetails)
                    .then((resp: Details) => {
                        if (resp) {
                            this.$store.dispatch('addApplicationMessages', { class: 'success', messages: ["Data updated successfully"] });
                            this.hearingDetails = resp;
                        }

                        this.$store.dispatch('isLoading', false);
                    })
            })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/docketing/pages/hearingdetails/detailsform/detailsform.ts